module.exports = __webpack_public_path__ + "img/Girl_030024.20dac749.png";